const LocalizationDropDown = function() {

  function init() {
    const countries = {
      '-- Please Select --': {},
      'Austria (de)': {
        locale: 'de_AT',
        currency: 'EUR',
        number: 'de_at'
      },
      'Austria (en)': {
        locale: 'en_AT',
        currency: 'EUR',
        number: 'en_at'
      },
      'Belgium (en)': {
        locale: 'en_BE',
        currency: 'EUR',
        number: 'en_be'
      },
      'Belgium (fr)': {
        locale: 'fr_BE',
        currency: 'EUR',
        number: 'fr_be'
      },
      'China (zh)': {
        locale: 'zh_CN',
        currency: 'RMB',
        number: 'zh_cn'
      },
      'Czech Republic (en)': {
        locale: 'en_CZ',
        currency: 'EUR',
        number: 'en_cz'
      },
      'Denmark (en)': {
        locale: 'en_DK',
        currency: 'EUR',
        number: 'en_dk'
      },
      'Estonia (de)': {
        locale: 'de_EE',
        currency: 'EUR',
        number: 'de_ee'
      },
      'Estonia (en)': {
        locale: 'en_EE',
        currency: 'EUR',
        number: 'en_ee'
      },
      'France (en)': {
        locale: 'en_FR',
        currency: 'EUR',
        number: 'en_fr'
      },
      'France (fr)': {
        locale: 'fr_FR',
        currency: 'EUR',
        number: 'fr_fr'
      },
      'Finland (de)': {
        locale: 'de_FL',
        currency: 'EUR',
        number: 'de_fl'
      },
      'Finland (en)': {
        locale: 'en_FI',
        currency: 'EUR',
        number: 'en_fi'
      },
      'Germany (en)': {
        locale: 'en_DE',
        currency: 'EUR',
        number: 'en_de'
      },
      'Germany (de)': {
        locale: 'de_DE',
        currency: 'EUR',
        number: 'de_de'
      },
      'Greece (en)': {
        locale: 'en_GR',
        currency: 'EUR',
        number: 'en_gr'
      },
      'Hungary (en)': {
        locale: 'en_HU',
        currency: 'EUR',
        number: 'en_hu'
      },
      'Italy (it)': {
        locale: 'it_IT',
        currency: 'EUR',
        number: 'it_it'
      },
      'Italy (en)': {
        locale: 'en_IT',
        currency: 'EUR',
        number: 'en_it'
      },
      'Ireland (en)': {
        locale: 'en_IE',
        currency: 'EUR',
        number: 'en_ie'
      },
      'Japan (jp)': {
        locale: 'ja_JP',
        currency: 'JPG',
        number: 'ja_jp'
      },
      'Latvia (en)': {
        locale: 'en_LV',
        currency: 'EUR',
        number: 'en_lv'
      },
      'Latvia (de)': {
        locale: 'de_LV',
        currency: 'EUR',
        number: 'de_lv'
      },
      'Luxembourg (en)': {
        locale: 'en_LU',
        currency: 'EUR',
        number: 'en_lu'
      },
      'Luxembourg (fr)': {
        locale: 'fr_LU',
        currency: 'EUR',
        number: 'fr_lu'
      },
      'Netherlands (en)': {
        locale: 'en_NL',
        currency: 'EUR',
        number: 'en_nl'
      },
      'Poland (en)': {
        locale: 'en_PL',
        currency: 'EUR',
        number: 'en_pl'
      },
      'Portugal (en)': {
        locale: 'en_PT',
        currency: 'EUR',
        number: 'en_pt'
      },
      'Slovakia (en)': {
        locale: 'en_SK',
        currency: 'EUR',
        number: 'en_sk'
      },
      'Slovakia (de)': {
        locale: 'de_SK',
        currency: 'EUR',
        number: 'de_sk'
      },
      'Spain (en)': {
        locale: 'en_ES',
        currency: 'EUR',
        number: 'en_es'
      },
      'Spain (es)': {
        locale: 'es_ES',
        currency: 'EUR',
        number: 'es_es'
      },
      'Sweden (en)': {
        locale: 'en_SE',
        currency: 'EUR',
        number: 'en_se'
      },
      'Switzerland (en)': {
        locale: 'en_CH',
        currency: 'CHF',
        number: 'en_CH'
      },
      'Switzerland (de)': {
        locale: 'de_CH',
        currency: 'CHF',
        number: 'en_CH'
      },
      'Switzerland (fr)': {
        locale: 'fr_CH',
        currency: 'CHF',
        number: 'en_CH'
      },
      'UK (en)': {
        locale: 'en_UK',
        currency: 'GBP',
        number: 'en_uk'
      },
      'USA (en)': {
        locale: 'en_us',
        currency: 'USD',
        number: 'en_us'
      }
    };
    window.countries = countries;
    const l18n = document.createElement('script');
    l18n.src = '//fluid-implementations.s3.amazonaws.com/toolkit/libs/jquery.l18n/jquery.l18n.js';
    l18n.type = 'text/javascript';
    l18n.async = 'true';
    l18n.onload = l18n.onreadystatechange = function() {
      const rs = this.readyState;
      if (rs && rs !== 'complete' && rs !== 'loaded') {
        return;
      }
      try {
        // we need to use the jquery available on the window scope.
        // That one is the one we add our l18n.
        window.$('body').l18n(window.countries, {}, {});
      } catch (e) {
        console.log('localization error', e);
      }
    };
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(l18n, s);
  }
  /**
   *  Expose Public Properties/Methods
   */
  return {
    init
  };
};

module.exports = LocalizationDropDown;
